<mat-toolbar class="topbar gap-10">




  <!-- Mobile Menu -->

  <button mat-icon-button (click)="toggleMobileNav.emit()" class="d-flex  justify-content-center">
    <i-tabler name="menu-2" class="icon-20 d-flex"></i-tabler>
  </button>


  <!-- <img src="assets/images/logo/nhrdf.png" [width]="400" /> -->
  <img src="assets/images/logo/nhrdf.png" class="header-logo" />
  

  <!-- <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Notifications">
    <i-tabler class="d-flex" name="bell" matBadge="1" matBadgeColor="primary"></i-tabler>
  </button>
  <mat-menu #menu="matMenu">
    <button mat-menu-item>Item 1</button>
    <button mat-menu-item>Item 2</button>
  </mat-menu> -->


  <span class="flex-1-auto"></span>

  <!-- --------------------------------------------------------------- -->
  <!-- profile Dropdown -->
  <!-- --------------------------------------------------------------- -->
  <!-- <b class="fs-6">{{sessionGet?.name}}</b> -->
  <b class="fs-6">{{userRole ? userRole : sessionGet?.name}} ({{findUserRole(sessionGet?.role | uppercase )}})</b>
  <button class="rounded-pill" mat-mini-fab [matMenuTriggerFor]="profilemenu" aria-label="Notifications">
    <img src="/assets/images/profile/user-1.jpg" class="rounded-circle object-cover d-block" width="35" />
  </button>

  <mat-menu #profilemenu="matMenu" class="cardWithShadow topbar-dd" xPosition="before">
    <button mat-menu-item routerLink="/profile">
      <mat-icon class="d-flex align-items-center"><i-tabler name="user" class="icon-18 d-flex"></i-tabler></mat-icon>My
      Profile
    </button>
    <button mat-menu-item routerLink="/changePassword">
      <mat-icon class="d-flex align-items-center"><i-tabler name="lock-cog" class="icon-18 d-flex"></i-tabler></mat-icon>Change Password
    </button>
    <!-- <button mat-menu-item>
      <mat-icon class="d-flex align-items-center"><i-tabler name="mail" class="icon-18 d-flex"></i-tabler></mat-icon>My
      Account
    </button>
    <button mat-menu-item>
      <mat-icon class="d-flex align-items-center"><i-tabler name="list-check"
          class="icon-18 d-flex"></i-tabler></mat-icon>My Task
    </button> -->

    <div class="p-x-12 m-t-12">
      <a mat-stroked-button class="w-100 secondary-button" (click)="logout()">Logout</a>
    </div>
  </mat-menu>
</mat-toolbar>